// Tokens da identidade "Aeros Dark" — spec:
// docs/superpowers/specs/2026-08-31-layout-aeros-dark-design.md
export const AEROS = Object.freeze({
  cyan: "#22D3EE",
  success: "#34D399",
  warning: "#FBBF24",
  error: "#F87171",
  info: "#22D3EE",
  defaultPrimary: "#A044FF",
  avatarCycle: ["#22D3EE", "#C08BFF", "#34D399", "#FBBF24", "#F87171", "#7DD3FC"],
  fontDisplay: "'Space Grotesk', 'Inter', sans-serif",
  // Tons escurecidos das cores de estado, usados como cor do TEXTO (não do
  // dot/ícone) sobre pills translúcidas no tema claro — o tom vívido direto
  // (AEROS.success etc.) sobre alpha(color, 0.10-0.12) composto em #FFFFFF
  // mede 1.59-2.51:1. Estes tons medem ≥4.5:1 (pior caso: surface2 #F0F1F7,
  // alpha 0.12) — ver contrast.py no relatório da auditoria.
  stateTextOnLight: {
    success: "#047857",
    warning: "#92600A",
    error: "#B91C1C",
    info: "#0B647F",
    purple: "#7E22CE",
  },
});

export const buildAerosPalette = (mode) =>
  mode === "light"
    ? {
        background: "#F6F7FB",
        surface: "#FFFFFF",
        surface2: "#F0F1F7",
        sidebar: "#FFFFFF",
        textPrimary: "#171A23",
        textSecondary: "#5B6376",
        textTertiary: "#5B6376",
        border: "rgba(15, 20, 40, 0.08)",
        borderStrong: "rgba(15, 20, 40, 0.16)",
      }
    : {
        background: "#0B0D14",
        surface: "#12151F",
        surface2: "#1A1E2C",
        sidebar: "#0E1119",
        textPrimary: "#F1F2F6",
        textSecondary: "#9CA3B8",
        textTertiary: "#5B6376",
        border: "rgba(255, 255, 255, 0.08)",
        borderStrong: "rgba(255, 255, 255, 0.16)",
      };

export const aerosGradient = (primary) =>
  `linear-gradient(135deg, ${primary}, ${AEROS.cyan})`;

export const mixHex = (hexA, hexB, ratio = 0.5) => {
  const parse = (h) => {
    const s = h.replace("#", "").slice(0, 6);
    return [0, 2, 4].map((i) => parseInt(s.slice(i, i + 2), 16));
  };
  const [a, b] = [parse(hexA), parse(hexB)];
  const mixed = a.map((c, i) => Math.round(c + (b[i] - c) * ratio));
  return "#" + mixed.map((c) => c.toString(16).padStart(2, "0")).join("").toUpperCase();
};

export const contrastTextFor = (hexColor) => {
  const hex = hexColor.replace("#", "").slice(0, 6);
  const [r, g, b] = [0, 2, 4].map((i) =>
    parseInt(hex.slice(i, i + 2), 16) / 255
  );
  const lin = (c) =>
    c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  const luminance = 0.2126 * lin(r) + 0.7152 * lin(g) + 0.0722 * lin(b);
  return luminance > 0.35 ? "#07080D" : "#F1F2F6";
};

// Cor de texto legível para uma pill/chip cujo bg é alpha(color, 0.10-0.12).
// No dark, o tom vívido já passa (>=5.2:1). No light, o tom vívido direto
// não passa (1.6-2.5:1) — usa o par escurecido de stateTextOnLight quando
// `stateKey` bate com um dos estados conhecidos; senão escurece a própria
// `color` (mixHex com preto, peso 0.45 — testado com amostras de cores de
// tag/fila arbitrárias, pior caso 5.28:1 sobre surface2 alpha 0.12).
export const stateText = (theme, color, stateKey) => {
  if (theme.palette.type !== "light") return color;
  if (stateKey && AEROS.stateTextOnLight[stateKey]) {
    return AEROS.stateTextOnLight[stateKey];
  }
  return mixHex(color, "#000000", 0.45);
};
